import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  addHtmlRootEventListener, appendHtmlElementChild,
  getHtmlElement, removeHtmlElementClass,
  renderWebComponent, setHtmlElementContent
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import styles from '../../styles/modal.css'
import { EventBusComponent } from "../EventBusComponent";
import I18n from 'i18n.js.erb';

let root = null;

export class SubmissionListBlockModalComponent extends HTMLElement {

  eventBus = null;
  modal = null;
  static instance = null;

  static getInstance(parentRoot, submissionList) {
    if (!SubmissionListBlockModalComponent.instance) {
      SubmissionListBlockModalComponent.instance = new SubmissionListBlockModalComponent({ submissionList: submissionList });
      appendHtmlElementChild(parentRoot, SubmissionListBlockModalComponent.instance)
    }
    addHtmlElementClass(root, 'blockModal', 'show');
    return SubmissionListBlockModalComponent.instance;
  }


  constructor(props) {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
    this.props = props;
    root = this.shadowRoot;
    this.render();
  }

  connectedCallback() {
    const modal = getHtmlElement(root, 'blockModal');
    addHtmlElementEventListener(root, 'closeButton', 'click', () => modal.classList.remove("show"));
    addHtmlRootEventListener(window, 'keydown', (e) => e.key === 'Escape' ? modal.classList.remove("show") : {});
    // window.top.document.addEventListener("click", function(e) {
    //   if (!modal.contains(e.target)) {
    //     modal.classList.remove("show");
    //   }
    // });
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => {
      this.props.submissionList = { ...submissionList};
      this.setGraderCompanyData();
    });
  }


  // Funzione che renderizza sull'interfaccia grafica i dati relativi alla casa di gradazione a cui l'utente vuole
  // inviare la sua submission list
  setGraderCompanyData() {
    setHtmlElementContent(
      this.shadowRoot,
      'submission_list_items_max_number_text1',
      I18n.t('js.editSubmissionListPage.webComponent.block.text1')
        .replaceAll(':order_type', I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${this.props.submissionList.service_type || (this.props.submissionList.speed === 'expedit' ? 'pro' : 'basic')}.title`))
        .replaceAll(':items_threshold', this.props.submissionList.grader_company[`${this.props.submissionList.speed === 'expedit' ? 'expedit_' : ''}submission_list_items_max_number`])
    );
    setHtmlElementContent(this.shadowRoot, 'email', this.props.submissionList.grader_company.email);
    setHtmlElementContent(this.shadowRoot, 'phone', this.props.submissionList.grader_company.phone);

    if (this.props.submissionList.is_middleman_for_company) {
      addHtmlElementClass(this.shadowRoot, 'customer-care', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'email_container', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'phone_container', 'd-none');
    } else {
      removeHtmlElementClass(this.shadowRoot, 'customer-care', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'email_container', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'phone_container', 'd-none');
    }
  }
  


  render() {
    const html = `      
      <div class="modal fade" id="blockModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" id="modalContainer">
          <div class="modal-content">
            <div class="modal-body" id="body">
              <div class="row pl-3">
                <div class="col-12 text-left pl-0">
                  <p class="text-center">
                    <span id="submission_list_items_max_number_text1"></span>
                  </p>
                  <p class="text-center">
                    ${I18n.t('js.editSubmissionListPage.webComponent.block.text3')}
                  </p>
                  <p id="customer-care" class="text-center">
                    ${I18n.t('js.editSubmissionListPage.webComponent.block.text4')}
                  </p>
                  <p id="email_container" class="text-center">
                    ${I18n.t('js.editSubmissionListPage.webComponent.block.text5')}:
                    <span id="email"></span>
                  </p>
                  <p id="phone_container" class="text-center">
                    ${I18n.t('js.editSubmissionListPage.webComponent.block.text6')}:
                    <span id="phone"></span>
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" 
                class="btn-standard bg-aig-gradient color-white br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
                data-dismiss="modal" id="closeButton"
              >
                ${I18n.t('js.common.ok').toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, root, [commonStyles, styles]);
    this.setGraderCompanyData();
  }
}

window.customElements.define("submission-list-block-modal-component", SubmissionListBlockModalComponent);